import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getEmployeeSessions, getEmployeeAssignments, getEmployeeTools, getCompanyEmployeeInfo } from '../../../../../../redux/Employee/employeesSlice';
import ToolManagmentCard from '../../../../../../common/element/Card/ToolManagmnetCard';
import { selectEmployeeSessions, selectEmployeeSessionsLoading, selectEmployeeAssignments, selectEmployeeAssignmentsLoading, selectEmployeeTools, selectEmployeeToolsLoading } from '../../../../../../redux/Employee/employeesSelector';
import ThreeDotBouncingLoader from '../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder';
import { formatToolName } from '../../../../../../common/Formatters.js/formatters';

const OverViewEmployee = ({ companyData ,loading }) => {
  console.log(companyData ,"companyDatacompanyData")
  const dispatch = useDispatch();
  const location = useLocation();

  // Read employeeId from query params and fetch compact sessions for overview
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const employeeId = searchParams.get('empId');
    if (employeeId) {
      dispatch(getEmployeeSessions({ employeeId, view: 'compact' }));
  dispatch(getEmployeeAssignments({ employeeId, view: 'compact' }));
  dispatch(getEmployeeTools({ employeeId, view: 'compact' }));
    dispatch(getCompanyEmployeeInfo({ companyEmployeeId: employeeId }));
    }
  }, [location.search, dispatch]);

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "bg-green-100 text-green-700";
      case "upcoming":
        return "bg-blue-100 text-blue-700";
      case "cancelled":
        return "bg-red-100 text-red-700";
      case "ongoing":
        return "bg-yellow-100 text-yellow-700";
         case "pending":
        return "bg-yellow-100 text-yellow-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };

  // Capitalize first letter for display
  const formatStatus = (status) => {
    if (!status && status !== 0) return 'N/A';
    const s = String(status);
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  // Get compact sessions from Redux (fetched by the useEffect above)
  const sessionsData = useSelector(selectEmployeeSessions);
  console.log(sessionsData, "sessionsDatasessionsDatasessionsData")
  const sessionsArray = Array.isArray(sessionsData) ? sessionsData : (sessionsData?.data || []);
  const sessionsLoading = useSelector(selectEmployeeSessionsLoading);
  // Assignments
  const assignmentsData = useSelector(selectEmployeeAssignments);
  const assignmentsArray = Array.isArray(assignmentsData) ? assignmentsData : (assignmentsData?.data || []);
  const assignmentsLoading = useSelector(selectEmployeeAssignmentsLoading);

  // Employee Tools (used by Assessments section)
  const employeeToolsData = useSelector(selectEmployeeTools);
  const toolsArray = Array.isArray(employeeToolsData) ? employeeToolsData : (employeeToolsData?.data || []);
  const toolsLoading = useSelector(selectEmployeeToolsLoading);


  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Left Column - Overview and Sessions */}
      <div className="space-y-6">
        {/* Overview Card */}
        <ToolManagmentCard>
          <div className="flex justify-between items-center pb-4 border-b border-gray-200">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">Overview</h2>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <ThreeDotBouncingLoader />
            </div>) : 
              <div className="py-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Phone number</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyData?.employee_mobile_number || 'N/A'}</p>
            </div>

            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Company Name</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyData?.company_name || 'N/A'}</p>
            </div>

            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Company HR Name</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyData?.hr_name || 'N/A'}</p>
            </div>

            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Company HR Email</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyData?.hr_email || 'N/A'}</p>
            </div>

            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Company HR Phone Number</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyData?.hr_mobile_number || 'N/A'}</p>
            </div>
          </div>
          }
        
        </ToolManagmentCard>

        {/* Sessions Card */}
        <ToolManagmentCard>
          <div className="pb-3">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] text-start">Sessions</h2>
          </div>
          <div className='border-b border-gray-200 mb-3'></div>
          <div className="bg-white overflow-hidden">
            {sessionsLoading ? (
              <div className="flex justify-center items-center h-40">
                <ThreeDotBouncingLoader />
              </div>
            ) : (
              <div className="max-h-[300px] overflow-y-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-[#FFF4E5]">
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Name</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {sessionsArray.length === 0 ? (
                      <tr className="border-t border-gray-200 text-start">
                        <td colSpan="3" className="py-6 px-4 text-center font-lato font-medium text-sm leading-[1.5] text-[#98A2B3]">No data</td>
                      </tr>
                    ) : (
                      sessionsArray.map((session, index) => (
                        <tr key={session.id || index} className="border-t border-gray-200 text-start">
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{index + 1}</td>
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{session.session_name || session.companySession?.session_name || session.sessionName || 'N/A'}</td>
                          <td>
                            <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${getStatusClass(session.status || session.companySession?.status)}`}>
                              {formatStatus(session.status || session.companySession?.status)}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </ToolManagmentCard>
      </div>

      {/* Right Column - Assessments and Home Activity */}
      <div className=" space-y-6">
        {/* Assessments Card */}
        <ToolManagmentCard>
          <div className="pb-3">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] text-start">Assessments</h2>
          </div>
          <div className='border-b border-gray-200 mb-3'></div>
          <div className="bg-white overflow-hidden">
            {toolsLoading ? (
              <div className="flex justify-center items-center h-40">
                <ThreeDotBouncingLoader />
              </div>
            ) : (
              <div className="max-h-[300px] overflow-y-auto">
                <table className="w-full ">
                  <thead>
                    <tr className="bg-[#FFF4E5]">
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Name</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {toolsArray.length === 0 ? (
                      <tr className="border-t border-gray-200 text-start">
                        <td colSpan="3" className="py-6 px-4 text-center font-lato font-medium text-sm leading-[1.5] text-[#98A2B3]">No data</td>
                      </tr>
                    ) : (
                      toolsArray.map((tool, index) => (
                        <tr key={tool.id || index} className="border-t border-gray-200 text-start">
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{index + 1}</td>
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{formatToolName(tool.tool || tool.name || tool.title || 'N/A')}</td>
                          <td>
                            <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${getStatusClass(tool.status || tool.tool_status || tool.assignment_status)}`}>
                              {formatStatus(tool.status || tool.tool_status || tool.assignment_status)}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </ToolManagmentCard>

        {/* Home Activity Card */}
        <ToolManagmentCard>
          <div className="pb-3">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] text-start">Assignment</h2>
          </div>
          <div className='border-b border-gray-200 mb-3'></div>
          <div className="bg-white overflow-hidden">
            {assignmentsLoading ? (
              <div className="flex justify-center items-center h-40">
                <ThreeDotBouncingLoader />
              </div>
            ) : (
              <div className="max-h-[300px] overflow-y-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-[#FFF4E5]">
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Name</th>
                      <th className="py-3 px-4 text-left font-lato font-medium text-sm leading-[1.5] text-[#475467]">Status</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {assignmentsArray.length === 0 ? (
                      <tr className="border-t border-gray-200 text-start">
                        <td colSpan="3" className="py-6 px-4 text-center font-lato font-medium text-sm leading-[1.5] text-[#98A2B3]">No data</td>
                      </tr>
                    ) : (
                      assignmentsArray.map((activity, index) => (
                        <tr key={activity.id || index} className="border-t border-gray-200 text-start">
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{index + 1}</td>
                          <td className="py-3 px-4 font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">{activity.assignment_name || activity.name || 'N/A'}</td>
                          <td>
                            <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${getStatusClass(activity.status || activity.assignment_status)}`}>
                              {formatStatus(activity.status || activity.assignment_status)}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </ToolManagmentCard>
      </div>
    </div>
  );
};

export default OverViewEmployee;
